import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSemiRain({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8484 23.8998C10.6265 24.5113 10.9308 24.9092 11.4218 25.0882C11.9127 25.2672 12.4025 25.158 12.6263 24.5465C12.8482 23.935 12.5129 22.0933 12.5129 22.0933C12.5129 22.0933 11.071 23.2883 10.849 23.8998H10.8484Z"
        fill="white"
      />
      <path
        d="M16.0325 23.8998C15.81 24.5113 16.1148 24.9092 16.6058 25.0882C17.0968 25.2672 17.5866 25.158 17.8104 24.5465C18.0323 23.935 17.697 22.0933 17.697 22.0933C17.697 22.0933 16.255 23.2883 16.0331 23.8998H16.0325Z"
        fill="white"
      />
      <path
        d="M21.7595 10.8474C21.7124 10.8474 21.6671 10.8528 21.6205 10.8546C21.0973 8.64541 19.1178 7 16.7487 7C14.2597 7 12.1997 8.81604 11.8095 11.1947C11.4987 11.1082 11.1736 11.0586 10.8341 11.0586C9.11054 11.0586 7.67155 12.262 7.30345 13.8728C5.95574 14.4026 5 15.7109 5 17.2465C5 19.2481 6.62214 20.8708 8.62432 20.8708H21.7601C24.5289 20.8708 26.7727 18.627 26.7727 15.8594C26.7727 13.0918 24.5283 10.8468 21.7601 10.8468L21.7595 10.8474Z"
        fill="white"
      />
    </svg>
  );
}
